export default __webpack_public_path__ + "static/media/linkedin.d415d4e2.png";